(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'react', 'lodash', '@material-ui/core/styles', '@material-ui/core/Stepper', '@material-ui/core/Step', '@material-ui/core/StepButton', '@material-ui/core/Button', '@material-ui/core/Typography', '@material-ui/icons/AdjustRounded', '@material-ui/icons/CheckCircleRounded', '@material-ui/icons/FiberManualRecordOutlined'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('react'), require('lodash'), require('@material-ui/core/styles'), require('@material-ui/core/Stepper'), require('@material-ui/core/Step'), require('@material-ui/core/StepButton'), require('@material-ui/core/Button'), require('@material-ui/core/Typography'), require('@material-ui/icons/AdjustRounded'), require('@material-ui/icons/CheckCircleRounded'), require('@material-ui/icons/FiberManualRecordOutlined'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.lodash, global.styles, global.Stepper, global.Step, global.StepButton, global.Button, global.Typography, global.AdjustRounded, global.CheckCircleRounded, global.FiberManualRecordOutlined);
    global.index = mod.exports;
  }
})(this, function (exports, _extends2, _react, _lodash, _styles, _Stepper, _Step, _StepButton, _Button, _Typography, _AdjustRounded, _CheckCircleRounded, _FiberManualRecordOutlined) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  var _Stepper2 = _interopRequireDefault(_Stepper);

  var _Step2 = _interopRequireDefault(_Step);

  var _StepButton2 = _interopRequireDefault(_StepButton);

  var _Button2 = _interopRequireDefault(_Button);

  var _Typography2 = _interopRequireDefault(_Typography);

  var _AdjustRounded2 = _interopRequireDefault(_AdjustRounded);

  var _CheckCircleRounded2 = _interopRequireDefault(_CheckCircleRounded);

  var _FiberManualRecordOutlined2 = _interopRequireDefault(_FiberManualRecordOutlined);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // import { leaf, platinum } from '../../styles/colors';
  // TODO: local imports in this file from peachjar-shared render in Cosmos, but not when used in portal. Hard coding leaf color

  var leaf = '#61c16c';

  var stone = '#b5b5b5';

  var styles = function styles(theme) {
    return {
      root: {
        width: '90%'
      },
      stepper: {
        backgroundColor: 'transparent'
      }
    };
  };

  var theme = (0, _styles.createMuiTheme)({
    palette: {
      primary: {
        main: leaf
      },
      secondary: {
        main: stone
      }
    },
    overrides: {
      MuiStepIcon: {
        root: {
          color: stone
        }
      }
    }
  });

  var PjStepper = function PjStepper(_ref) {
    var classes = _ref.classes,
        steps = _ref.steps;

    var getActiveStep = function getActiveStep(steps) {
      return (0, _lodash.findIndex)(steps, 'isActive');
    };
    var activeStep = getActiveStep(steps);

    var getIcon = function getIcon(step) {
      if (step.isActive) {
        return _react2.default.createElement(_AdjustRounded2.default, { color: 'primary' });
      } else if (step.isCompleted) {
        return _react2.default.createElement(_CheckCircleRounded2.default, { color: 'primary' });
      } else if (step.isReady) {
        return _react2.default.createElement(_FiberManualRecordOutlined2.default, { color: 'primary' });
      }
      return _react2.default.createElement(_FiberManualRecordOutlined2.default, { color: 'secondary' });
    };

    var getStepLabelStyles = function getStepLabelStyles(step) {
      return step.isReady ? { color: 'black' } : {};
    };

    return _react2.default.createElement(
      _styles.MuiThemeProvider,
      { theme: theme },
      _react2.default.createElement(
        'div',
        { className: classes.root },
        _react2.default.createElement(
          _Stepper2.default,
          {
            alternativeLabel: true,
            nonLinear: true,
            activeStep: activeStep,
            className: classes.stepper
          },
          steps.map(function (step, index) {
            var props = {};
            var buttonProps = {};
            return _react2.default.createElement(
              _Step2.default,
              (0, _extends3.default)({ key: step.id }, props),
              _react2.default.createElement(
                _StepButton2.default,
                (0, _extends3.default)({
                  onClick: step.onClickHandler,
                  completed: step.isCompleted,
                  icon: getIcon(step)
                }, buttonProps),
                _react2.default.createElement(
                  'span',
                  { style: getStepLabelStyles(step) },
                  step.label
                )
              )
            );
          })
        )
      )
    );
  };

  exports.default = (0, _styles.withStyles)(styles)(PjStepper);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Stepper/index.js
// module id = 563
// module chunks = 0